import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { GetMakesPayload, GetModelsPayload, GetStylesPayload } from '../models/vehicle.models';
import { VehicleService } from '../services/vehicle.service';
import {
  GetMakes,
  GetMakesFail,
  GetMakesSuccess,
  GetModels,
  GetModelsFail,
  GetModelsSuccess,
  GetStyles,
  GetStylesFail,
  GetStylesSuccess,
  LookupVinYear,
  LookupVinYearFail,
  LookupVinYearSuccess
} from './vehicle.actions';

export const getByVinAndYearEffect = createEffect(
  (actions$ = inject(Actions), vehicleService = inject(VehicleService)) => {
    return actions$.pipe(
      ofType(LookupVinYear),
      map(action => action.payload),
      switchMap(payload =>
        vehicleService.getVehicleByVinAndYear(payload).pipe(
          map(response => {
            return LookupVinYearSuccess(response);
          }),
          catchError(error => of(LookupVinYearFail(error)))
        )
      )
    );
  },
  { functional: true }
);

export const getMakesEffect = createEffect(
  (actions$ = inject(Actions), vehicleService = inject(VehicleService)) => {
    return actions$.pipe(
      ofType(GetMakes),
      map(action => action.payload),
      switchMap((payload: GetMakesPayload) =>
        vehicleService.getVehicleMakes(payload).pipe(
          map(response => {
            return GetMakesSuccess(response);
          }),
          catchError(error => of(GetMakesFail(error)))
        )
      )
    );
  },
  { functional: true }
);

export const getModelsEffect = createEffect(
  (actions$ = inject(Actions), vehicleService = inject(VehicleService)) => {
    return actions$.pipe(
      ofType(GetModels),
      map(action => action.payload),
      switchMap((payload: GetModelsPayload) =>
        vehicleService.getVehicleModels(payload).pipe(
          map(response => {
            return GetModelsSuccess(response);
          }),
          catchError(error => of(GetModelsFail(error)))
        )
      )
    );
  },
  { functional: true }
);

export const getStylesEffect = createEffect(
  (actions$ = inject(Actions), vehicleService = inject(VehicleService)) => {
    return actions$.pipe(
      ofType(GetStyles),
      map(action => action.payload),
      switchMap((payload: GetStylesPayload) =>
        vehicleService.getVehicleStyles(payload).pipe(
          map(response => {
            return GetStylesSuccess(response);
          }),
          catchError(error => of(GetStylesFail(error)))
        )
      )
    );
  },
  { functional: true }
);
